/**
 * Wrapper for BillQuickCreateDialog that handles create mutation internally.
 * Used by QuickCreateMenu to create new bills.
 */

import { useTranslation } from 'react-i18next';
import { BillQuickCreateDialog } from '../../modules/accounting/components/BillQuickCreateDialog';
import { useCreateBill } from '../../modules/accounting/hooks/useBills';
import { useNotification } from '../../shared/context/NotificationContext';
import type { BillCreate } from '../../modules/accounting/types';

interface QuickCreateBillFormProps {
  open: boolean;
  onClose: () => void;
}

export function QuickCreateExpenseForm({ open, onClose }: QuickCreateBillFormProps) {
  const { t } = useTranslation('accounting');
  const { showSuccess } = useNotification();
  const createBill = useCreateBill();

  const handleSubmit = async (data: BillCreate) => {
    try {
      await createBill.mutateAsync(data);
      showSuccess(t('bills.createSuccess'));
      onClose();
    } catch {
      // The global mutation-error handler shows the specific translated toast.
    }
  };

  return (
    <BillQuickCreateDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={createBill.isPending}
    />
  );
}
